import { render, staticRenderFns } from "./AbsenceModal.vue?vue&type=template&id=63ec5422&scoped=true"
import script from "./AbsenceModal.vue?vue&type=script&lang=js"
export * from "./AbsenceModal.vue?vue&type=script&lang=js"
import style0 from "./AbsenceModal.vue?vue&type=style&index=0&id=63ec5422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec5422",
  null
  
)

export default component.exports